import { useCallback } from 'react'

import { useGetByTenantOrderOutstandingAndAssetIdQuery } from '@/api/rtk-api'
import { TENANT } from '@/const'

import { GroupedTab } from './grouped-tabs-panel'
import { OrderOutstandingDetails } from './order-outstanding-details'
import { OrderTrades } from './order-trades'
import { OrdersDetailsTemplate } from './orders-details-template'
import { OrderType, OutstandingOrder } from './orders-types'

export interface OrdersOutstandingProps {
  assetId: string
}
export const OrdersOutstanding = ({ assetId }: OrdersOutstandingProps) => {
  const { data, isLoading } = useGetByTenantOrderOutstandingAndAssetIdQuery({
    assetId,
    tenant: TENANT
  })

  const getTabs = useCallback(
    (order: OutstandingOrder): [GroupedTab, GroupedTab] => [
      {
        component: <OrderOutstandingDetails order={order} />,
        heading: 'Details',
        value: 'details'
      },
      {
        component: <OrderTrades order={order} />,
        heading: 'Trades',
        value: 'trades'
      }
    ],
    []
  )

  return (
    <div className="mx-12 mt-4">
      <OrdersDetailsTemplate
        getTabs={getTabs}
        isLoading={isLoading}
        orders={data}
        type={OrderType.Outstanding}
      />
    </div>
  )
}
